
<div class="registered-row" style="margin-left: 40px; margin-top: 20px; margin-bottom: 20px;">
    <h2 class="title">Painéis Cadastrados</h2>
    <button class="mt-3 new-panel-btn" *ngIf="mode === 'all'" (click)="newForm()" style="float: right;" mat-raised-button>
        <mat-icon>add_circle</mat-icon>
        Novo Painel
    </button>
</div>
<!-- PAINEIS -->
<div style="margin: 40px;">
    <div class="card">
        <table *ngIf="mode==='all'" mat-table [dataSource]="paineis" class="demo-table">
            <ng-container matColumnDef="nome" sticky>
                <th mat-header-cell *matHeaderCellDef> Nome </th>
                <td style="width: 35%" mat-cell *matCellDef="let element"> {{element.nome}} </td>
            </ng-container>
            <ng-container matColumnDef="url">
                <th mat-header-cell *matHeaderCellDef> URL </th>
                <td style="width: 30%" mat-cell *matCellDef="let element"> <a href="{{element.url}} ">
                        {{element.url}} </a> </td>
            </ng-container>
            <ng-container matColumnDef="datacriacao">
                <th mat-header-cell *matHeaderCellDef> Data Criação </th>
                <td style="width: 10%" mat-cell *matCellDef="let element"> {{element.datacriacao}} </td>
            </ng-container>
            <ng-container matColumnDef="status">
                <th mat-header-cell *matHeaderCellDef> Status </th>
                <td style="width: 20%" mat-cell *matCellDef="let element"> {{formatStatus(element.status)}} </td>
            </ng-container>
            <ng-container matColumnDef="edit" stickyEnd>
                <th mat-header-cell *matHeaderCellDef></th>
                <td style="width: 5%" mat-cell *matCellDef="let element; let i = index">
                    <button (click)="newForm(i)" style="margin:10px" mat-raised-button class="purple-btn">
                        <mat-icon>edit</mat-icon>
                    </button>
                    <button [disabled]="showSpinner ? true : false" (click)="deletePainel(element.id)"
                        style="margin:10px" mat-raised-button class="gray-btn" color="accent">
                        <mat-spinner diameter='18' [style.display]="showSpinner ? 'inline-block' : 'none'">
                        </mat-spinner>
                        <mat-icon>delete</mat-icon>
                    </button>
                </td>
            </ng-container>
            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>
        
        <mat-tab-group *ngIf="mode === 'form'" class="mt-5" dynamicHeight [(selectedIndex)]="tabGroupIndex">
            <mat-tab label="Dados Gerais do Cliente">
                <div layout="row" layout-padding>
                    <div class="flex" flex="20"></div>
                </div>
                <form [formGroup]="formPainel" style="margin: 40px">
                    <div>
                        <mat-form-field>
                            <mat-label>Nome</mat-label>
                            <input type="text" required formControlName=nome matInput>
                        </mat-form-field>
                        <mat-form-field style="margin: 10px">
                            <mat-label>Status</mat-label>
                            <mat-select required style="height: 10px !important;" formControlName=status>
                                <mat-option value=true>Sim</mat-option>
                                <mat-option value=false>Não</mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                </form>
            </mat-tab>
        
            <mat-tab label="Dados dos locais">
                <h2 class="wwTitle mt-5" style="margin-left: 40px">
                    Locais do Painel
                    <button *ngIf="painelLocalMode === 'all'" class="mt-3 new-panel-btn" (click)="newPainelLocalForm()" style="float: right;"
                        mat-raised-button> Novo Local
                        <mat-icon>add_circle</mat-icon>
                    </button>
                </h2>
                <div *ngIf="painelLocalMode==='form'">
                    <button style="margin-left: 40px" (click)="cleanPainelLocalForm()"
                        [disabled]="showSpinner ? true : false" mat-raised-button class="gray-btn">
                        <mat-spinner diameter='18' [style.display]="showSpinner ? 'inline-block' : 'none'">
                        </mat-spinner> Cancelar
                    </button>
                    <button [disabled]="showSpinner ? true : false" style="margin-left: 1%"
                        (click)="submitPainelLocalForm()" type="submit" mat-raised-button class="purple-btn">
                        <mat-spinner diameter='18' [style.display]="showSpinner ? 'inline-block' : 'none'">
                        </mat-spinner>Inserir Local
                    </button>
                </div>
                <table *ngIf="painelLocalMode==='all'" mat-table [dataSource]="paineisLocalEmpresa"
                    class="mat-elevation-z8 demo-table">
                    <ng-container matColumnDef="localid" sticky>
                        <th mat-header-cell *matHeaderCellDef> Local </th>
                        <td style="width: 35%" mat-cell *matCellDef="let element"> {{element.local}} </td>
                    </ng-container>
                    <ng-container matColumnDef="tipo">
                        <th mat-header-cell *matHeaderCellDef> Tipo </th>
                        <td style="width: 30%" mat-cell *matCellDef="let element"> {{element.tipo}} </td>
                    </ng-container>
                    <ng-container matColumnDef="edit" stickyEnd>
                        <th mat-header-cell *matHeaderCellDef style="height: 56px;"></th>
                        <td style="width: 5%" mat-cell *matCellDef="let element; let i = index">
                            <button *ngIf="painel.id" (click)="newPainelLocalForm(i)" style="margin:10px"
                                mat-raised-button class="purple-btn">
                                <mat-icon>edit</mat-icon>
                            </button>
                            <button [disabled]="showSpinner ? true : false" (click)="deletePainelLocal(i)"
                                style="margin:10px" mat-raised-button color="accent">
                                <mat-spinner diameter='18' [style.display]="showSpinner ? 'inline-block' : 'none'">
                                </mat-spinner>
                                <mat-icon>delete</mat-icon>
                            </button>
                        </td>
                    </ng-container>
                    <tr mat-header-row *matHeaderRowDef="displayedColumnsLocal"></tr>
                    <tr mat-row *matRowDef="let row; columns: displayedColumnsLocal;"></tr>
                </table>
                <div *ngIf="painelLocalMode === 'form'">
                    <form [formGroup]="formPainelLocal" style="margin: 40px">
                        <div class="form-inputs" style="flex-direction: row;">
                            <mat-form-field>
                                <mat-label>Tipo</mat-label>
                                <mat-select required style="height: 10px !important;" formControlName=tipo required>
                                    <mat-option value="local">Local</mat-option>
                                    <mat-option value="empresa">Empresa</mat-option>
                                </mat-select>
                            </mat-form-field>
                            <mat-form-field *ngIf="formPainelLocal.value.tipo === 'local'">
                                <mat-label>Locais</mat-label>
                                <mat-select formControlName="localid" style="height: 20px !important;" required>
                                    <mat-option *ngFor="let i = index; let local of locais;" [value]="local.id">
                                        {{local.nome}}</mat-option>
                                </mat-select>
                            </mat-form-field>
                            <mat-form-field *ngIf="formPainelLocal.value.tipo === 'empresa'">
                                <mat-label>Empresas</mat-label>
                                <mat-select formControlName="localid" style="height: 20px !important;">
                                    <mat-option *ngFor="let i = index; let empresa of empresas;" [value]="empresa.id">
                                        {{empresa.nome}}</mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>
                    </form>
                </div>
            </mat-tab>

            <mat-tab label="Agendas">
                <h2 class="wwTitle mt-5" style="margin-left: 40px">
                    Agendas do Painel
                    <button *ngIf="painelLocalMode === 'all'" class="mt-3 new-panel-btn" (click)="setTipoAgendaAndCreateForm()" style="float: right;" mat-raised-button> 
                        Nova Agenda <mat-icon>add_circle</mat-icon>
                    </button>
                </h2>
                <div *ngIf="painelLocalMode==='form'">
                    <button style="margin-left: 40px" (click)="cleanPainelLocalForm()"
                        [disabled]="showSpinner ? true : false" mat-raised-button class="gray-btn">
                        <mat-spinner diameter='18' [style.display]="showSpinner ? 'inline-block' : 'none'">
                        </mat-spinner> Cancelar
                    </button>
                    <button [disabled]="showSpinner ? true : false" style="margin-left: 1%"
                        (click)="submitPainelLocalForm()" type="submit" mat-raised-button class="purple-btn">
                        <mat-spinner diameter='18' [style.display]="showSpinner ? 'inline-block' : 'none'">
                        </mat-spinner>Inserir Agenda
                    </button>
                </div>
                <table *ngIf="painelLocalMode === 'all'" mat-table [dataSource]="paineisLocaisAgenda" class="mat-elevation-z8 demo-table">
                <ng-container matColumnDef="localid" sticky>
                    <th mat-header-cell *matHeaderCellDef> Agenda </th>
                    <td style="width: 35%" mat-cell *matCellDef="let element"> {{element.local}} </td>
                </ng-container>

                <ng-container matColumnDef="tipo">
                    <th mat-header-cell *matHeaderCellDef> Tipo </th>
                    <td style="width: 30%" mat-cell *matCellDef="let element"> {{element.tipo}} </td>
                </ng-container>

                <ng-container matColumnDef="edit" stickyEnd>
                    <th mat-header-cell *matHeaderCellDef style="height: 56px;"></th>
                    <td style="width: 5%" mat-cell *matCellDef="let element; let i = index">
                    <button *ngIf="painel.id" (click)="newPainelLocalForm(i)" style="margin:10px" mat-raised-button class="purple-btn">
                        <mat-icon>edit</mat-icon>
                    </button>
                    <button [disabled]="showSpinner ? true : false" (click)="deletePainelLocalAgenda(i)" style="margin:10px" mat-raised-button color="accent">
                        <mat-spinner diameter='18' [style.display]="showSpinner ? 'inline-block' : 'none'"></mat-spinner>
                        <mat-icon>delete</mat-icon>
                    </button>
                    </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="displayedColumnsLocal"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumnsLocal;"></tr>
                </table>

                <div *ngIf="painelLocalMode === 'form'">
                <form [formGroup]="formPainelLocal" style="margin: 40px">
                    <div class="form-inputs" style="flex-direction: row;">
                    <mat-form-field>
                        <mat-label>Agendas</mat-label>
                        <mat-select formControlName="localid" style="height: 20px !important;" required>
                        <mat-option *ngFor="let i = index; let agenda of agendas;" [value]="{ id: agenda.id, tipo: agenda.tipo }">
                            {{agenda.nome}}
                        </mat-option>
                        </mat-select>
                    </mat-form-field>
                    </div>

                    <ckeditor 
                        [config]="{versionCheck: false}" 
                        style="width: 100%;"
                        formControlName="messagecheckin">
                    </ckeditor>
                </form>
                </div>
            </mat-tab>
        </mat-tab-group>
        
        <div *ngIf="mode==='form'">
            <button (click)="cleanForm()" [disabled]="showSpinner ? true : false"
                mat-raised-button class="gray-btn">
                <mat-spinner diameter='18' [style.display]="showSpinner ? 'inline-block' : 'none'">
                </mat-spinner> Voltar
            </button>
        
            <button [disabled]="showSpinner ? true : false" style="margin-left: 1%" (click)="submitForm()" type="submit"
                mat-raised-button class="purple-btn">
                <mat-spinner diameter='18' [style.display]="showSpinner ? 'inline-block' : 'none'">
                </mat-spinner>Concluído
            </button>
        </div>
    </div>
</div>
